/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {EsriModuleService} from '../../../../esri-nlr/services/esri-module.service';
import {MapToolsService} from '../../../../services/map-tools.service';
import {PlanModelService} from '../../../../../common/service/plan-model.service';
import {PointService} from '../../../../services/features/point.service';
import {ToolServiceInterface} from './tool-service-interface';
import {first, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PointConstructionToolService implements ToolServiceInterface {
    title = 'PointConstructionToolService';

    constructor(
        private pointService: PointService,
        private esriModuleService: EsriModuleService,
        private mapToolsService: MapToolsService,
        private planModelService: PlanModelService
    ) {}

    create(attributes: any): Observable<any> {
        console.debug(`${this.title} - create`);
        return this.mapToolsService.activate('CONSTRUCTION_TOOLS_POINT', () => {
            this.createPoint(attributes).pipe(first()).subscribe();
        });
    }

    createPoint(attributes: any) {
        console.debug(`${this.title} - createPoint`);

        const pointAttributes = {};

        for (const [key, value] of Object.entries(attributes) as any[]) {
            if (value && typeof value === 'object') {
                pointAttributes[key] = value.id;
            } else {
                pointAttributes[key] = value;
            }
        }

        const pointGeometry = new this.esriModuleService.geometry.Point(attributes.x, attributes.y);
        pointGeometry.spatialReference = new this.esriModuleService.SpatialReference(this.planModelService.getSpatialReference());

        const pointGraphic = new this.esriModuleService.Graphic(pointGeometry);
        pointGraphic.attributes = pointAttributes;
        pointGraphic.attributes.visible = 'YES';

        return this.pointService.create(pointGraphic);
    }
}
